import React from "react";
import { createComponent } from "@lit/react";
import { BeamSubscriptionImpact as _BeamSubscriptionImpact } from "./index";

export const BeamSubscriptionImpact = createComponent({
  tagName: _BeamSubscriptionImpact.tagName,
  elementClass: _BeamSubscriptionImpact,
  react: React,
  events: {},
});

export default BeamSubscriptionImpact; // default alias for use with async import utils like next/dynamic and react.lazy
